import './_common.js';
import '../css/encourage-survey.scss';
import './ui-part/iframe-calendar.js';
import './ui-part/user-template.js';

let currentQuestionId = null;
let nextQuestionId = null;

function handleRadioInputClick(event)
{
    let radioInput = event.target;

    let questionId = radioInput.dataset.question;
    let answerId = radioInput.dataset.answer;

    let allFeedbacks = document.querySelectorAll(`.survey-question-feedback[data-question="${questionId}"]`);
    allFeedbacks.forEach(node => { node.hidden = true; });

    let feedback = document.querySelector(`.survey-question-feedback[data-question="${questionId}"][data-answer="${answerId}"]`);
    feedback.hidden = false;

    let nextQuestionButton = document.querySelector('.survey-next-question-button');
    nextQuestionButton.hidden = false;

    currentQuestionId = questionId;
    nextQuestionId = parseInt(questionId) + 1;
}

function handleNextQuestionButtonClick(event)
{
    let nextQuestionButton = event.target;

    let currentQuestionContainer = document.querySelector(`.survey-question[data-question="${currentQuestionId}"]`);
    let nextQuestionContainer = document.querySelector(`.survey-question[data-question="${nextQuestionId}"]`);

    currentQuestionContainer.hidden = true;
    nextQuestionButton.hidden = true;

    if (nextQuestionContainer) {
        nextQuestionContainer.hidden = false;
    }
    else {
        window.location += '?finished';
    }
}

function setupSurvey()
{
    let radioInputs = document.querySelectorAll('.survey-question-answer-radio');
    radioInputs.forEach(radioInput => {
        radioInput.addEventListener('click', handleRadioInputClick);
    });

    let nextQuestionButton = document.querySelector('.survey-next-question-button');
    nextQuestionButton.addEventListener('click', handleNextQuestionButtonClick);
}

document.addEventListener('DOMContentLoaded', () => {
    if (window.location.search === '?finished') {
        window.history.replaceState({}, document.title, window.location.pathname);
    }
    else {
        setupSurvey();
    }
});
